import React, { useEffect, useState } from 'react';
import { Carousel, Container } from 'react-bootstrap';
import HomeBody from '../HomeBody/HomeBody';
import HomeBanner from '../HomeBanner/HomeBanner';
import './Home.css';

const Home = () => {

    const [league, setLeague] = useState([]);
    useEffect(() => {
        const url = "https://www.thesportsdb.com/api/v1/json/2/all_leagues.php";
        fetch(url)
            .then(response => response.json())
            .then(data => {
                setLeague(data.leagues)
            })
    }, [])
    // console.log(league);

    return (
        <div className="home-container">
            <HomeBanner></HomeBanner>

            <Container>
                {
                    league.map(league => <HomeBody league={league} ></HomeBody>)
                }
                {/* <HomeBody></HomeBody> */}
            </Container>
            

        </div>
    );
};

export default Home;